import { render, staticRenderFns } from "./lookApprovalDetail.vue?vue&type=template&id=073398be&scoped=true"
import script from "./lookApprovalDetail.vue?vue&type=script&lang=js"
export * from "./lookApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./lookApprovalDetail.vue?vue&type=style&index=0&id=073398be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073398be",
  null
  
)

export default component.exports